import {Component, input, output, signal} from '@angular/core';
import {Button} from 'primeng/button';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-table-expand-controls',
  templateUrl: './table-expand-controls.component.html',
  imports: [Button, TranslocoPipe],
})
export class TableExpandControlsComponent {
  readonly expandAllDisabled = input(false);
  readonly collapseAllDisabled = input(false);
  readonly expandAll = output<void>();
  readonly collapseAll = output<void>();

  readonly expanded = signal(false);

  onExpandAll(): void {
    this.expanded.set(true);
    this.expandAll.emit();
  }

  onCollapseAll(): void {
    this.expanded.set(false);
    this.collapseAll.emit();
  }
}
